// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","orderCutoffTime":"orderCutoffTime_orderCutoffTime__WwhGn"};